export const GET_PROFILE = 'GET_PROFILE';
export const GET_UPDATEDPROFILE = 'GET_UPDATEDPROFILE';
export const GET_UPDATEDPROFILEFAVS = 'GET_UPDATEDPROFILEFAVS';
export const SET_PROFILE = 'SET_PROFILE';
export const CLEAR_PROFILE = 'CLEAR_PROFILE';
export const SAVE_STATE = 'SAVE_STATE';
